<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataEvento" type="datetime" disabled></date-picker>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Fonte Dati</label>
                    <b-form-select v-model="jsonData.fonteDati" :options="fonteDatiOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Altro</label>
                    <b-form-input v-model="jsonData.fonteDatiAltro" :disabled="jsonData.fonteDati !== 'ALTRO'"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI FISIOLOGICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Allergie</label>
                    <b-form-select v-model="jsonData.allergie" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Altro</label>
                    <b-form-input v-model="jsonData.allergieAltro" :disabled="jsonData.allergie !== 'SI'"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Fumo</label>
                    <b-form-select v-model="jsonData.fumo" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ANAMNESI PATOLOGICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Malattie Autoimmuni</label>
                    <b-form-select v-model="jsonData.malattieAutoimmuni" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <b-form-input v-model="jsonData.malattieAutoimmuniNote" :disabled="jsonData.malattieAutoimmuni !== 'SI'"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Assunzione Farmaci</label>
                    <b-form-select v-model="jsonData.assunzioneFarmaci" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <b-form-input v-model="jsonData.assunzioneFarmaciNote" :disabled="jsonData.assunzioneFarmaci !== 'SI'"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="INTERVENTI CHIRURGICI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Interventi Chirurgici</label>
                    <b-form-select v-model="jsonData.interventiChirurgici" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <b-form-input v-model="jsonData.interventiChirurgiciNote" :disabled="jsonData.interventiChirurgici !== 'SI'"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="PRECEDENTI TRATTAMENTI DI MEDICINA ESTETICA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Precedenti Trattamenti</label>
                    <b-form-select v-model="jsonData.precedentiTrattamentiMedicinaEstetica" :options="siNoOption" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <label class="sa-label-data">Note</label>
                    <b-form-input v-model="jsonData.precedentiTrattamentiMedicinaEsteticaNote" :disabled="jsonData.precedentiTrattamentiMedicinaEstetica !== 'SI'"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="MOTIVO DELLA VISITA" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-textarea v-model="jsonData.motivoVisita" no-resize rows="3"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="ESAME OBIETTIVO LOCALE" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-textarea v-model="jsonData.esameObiettivoLocale" no-resize rows="3"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="FARMACI" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-textarea v-model="jsonData.farmaci" no-resize rows="3"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../../../utility/UtilityMixin";
// import { VueEditor } from "vue2-editor";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],

    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    note: "",
                    dataEvento: new Date().getTime(),
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.jsonData.idAccettazione = this.$route.query.idAccettazione;
        me.jsonData.idPrenotazione = this.$route.query.idPrenotazione;
        me.jsonData.dataEvento = new Date().getTime();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        currentPage() {
            let me = this;
            me.loadDatiPacs();
        },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/anamnesibotox",
            tipoEvento: "ANAMNESI BOTOX",
            gruppo: "BOTOX",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            idRisorsa: null,
            disableCampi: false,
            listaRichieste: [],
            fonteDatiOption: [
                { value: "", text: "-Seleziona Valore-" },
                { value: "PAZIENTE", text: "PAZIENTE" },
                { value: "FAMILIARE", text: "FAMILIARE" },
                { value: "ALTRO", text: "ALTRO" },
            ],
            siNoOption: [
                { value: "", text: "-Seleziona Valore-" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            this.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    this.$emit("update", response.data.data);
                    // me.loadDatiPacs();
                    this.$emit("afterLoadData");
                });
            }
        },

        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios
                .get(link)
                .then((response) => {
                    me.linkPacs = "";
                    me.linkPacs = response.data.data.url;
                    // console.log(me.linkPacs);
                })
                .catch((error) => {
                    this.$emit("afterLoadData");
                    this.$bvModal
                        .msgBoxOk(error.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            console.log(value);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
        onUpdateConclusioni(data) {
            let me = this;
            me.jsonData.note = data;
            this.$emit("update", me.jsonData);
        },
    },
};
</script>

<style></style>
